import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getSelectedFacetString } from "utils/searchUtils";
import queryString from "query-string";
import axios from "utils/axios";
import useIsMounted from "hooks/useIsMounted";
import { Helmet } from "react-helmet";
import LogInMobilePopUp from "views/Auth/SignInSendMobileOTP/LogInMobilePopUp";
import { getUrl, updateBusinessProfile, UPDATE_BUSINESS_PROFILE_SUCCESS } from "actions/businessActions";
import BusinessNavbar from "views/Search2.0/components/BusinessPages/BusinessNavbar";
import BusinessProfileAbout from "views/Search2.0/components/BusinessPages/BusinessProfileAbout";
import BusinessProfileHead from "views/Search2.0/components/BusinessPages/BusinessProfileHead";
import BusinessOfferingPage from "views/Search2.0/components/BusinessPages/BusinessOfferingPage";
import Projects from "views/Search2.0/components/BusinessPages/Projects";
import TopClient from "views/Search2.0/components/BusinessPages/TopClient";
import Domains from "views/Search2.0/components/BusinessPages/Domains";
import VendorCategoriesView from "views/Search2.0/components/BusinessPages/VendorCategoriesView";
import AwardsCertification from "views/Search2.0/components/BusinessPages/AwardsCertification";
import { useState } from "react";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { useRef } from "react";
import NewBusinessProfileMobileView from "views/Search2.0/components/BusinessPages/MobileView/NewBusinessProfileMobileView";
import CertificateSection from "../components/CertificateSection";
import Awards from "../components/Awards";
import AddCategoryPopUp from "views/CompanyDirectory/components/AddCategoryPopUp";
import TrustedCompaniesSection from "views/NeevayNetwork/components/tableComponenets/TrustedCompaniesSection";

const NewMyBusinesspage = ({
  permissions,
  PublicProfile,
  profile,
  projects,
}) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down(1024));
  const isSm = useMediaQuery(theme.breakpoints.down(768));
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.auth.user);
  const userId = userProfile?.userId;
  const entityId = userProfile?.userEntity?.entityId;
  const supplierId = profile?.supplierId;
  const canViewTrustedCompanies = userProfile?.userEntity?.features?.some(
    (feature) => feature.featureName === "SUPPLIER_TRUSTED_COMPANIES" && feature.hasFeature === true,
  );
  const associationKey = `${userId}-${entityId}-${supplierId}`;
  const bProfile = profile?.businessProfile;
  const [categoryPopupOpen, setCategoryPopupOpen] = useState(false);
  const [categorySaving, setCategorySaving] = useState(false);
  const [categoryError, setCategoryError] = useState({ status: false, message: "" });
  let isAwardExists = false;
  const scrollContainerRef = useRef(null);
  const isEditView = true;
  const trustedCompaniesSection = canViewTrustedCompanies && userId && entityId && supplierId ? (
    <div className={isSm ? "mx-3 my-4 empty:hidden" : "mx-[46px] my-8 empty:hidden"}>
      <TrustedCompaniesSection
        key={associationKey}
        supplierId={supplierId}
        entityId={entityId}
        active
        associationKey={associationKey}
      />
    </div>
  ) : null;

  const selectedVendorForCategories = profile ? [{
    Company: profile?.businessName || bProfile?.businessName,
    businessName: profile?.businessName || bProfile?.businessName,
    vendorData: {
      vendorCategories: Array.isArray(profile?.vendorCategories) ? profile.vendorCategories : [],
    },
  }] : [];

  const buildBusinessProfilePayload = (vendorCategories) => ({
    businessName: profile?.businessName || bProfile?.businessName,
    businessEmail: bProfile?.businessEmail,
    gstin: bProfile?.gstin,
    businessMobile: bProfile?.businessMobile,
    contact: bProfile?.contact,
    businessType: bProfile?.businessType,
    businessHeadline: bProfile?.businessHeadline,
    description: bProfile?.description,
    businessCategory: bProfile?.businessCategory,
    establishYear: bProfile?.establishYear,
    domains: bProfile?.domains,
    projectCount: bProfile?.projectCount,
    certificates: bProfile?.certificates,
    websiteUrl: bProfile?.websiteUrl,
    supplierType: bProfile?.supplierType,
    stepperCount: bProfile?.stepperCount,
    annualTurnOver: bProfile?.annualTurnOver,
    vendorCategories,
  });

  const handleCategoryUpdate = async (vendorCategories) => {
    if (!profile?.supplierId) return;

    try {
      setCategorySaving(true);
      setCategoryError({ status: false, message: "" });
      await dispatch(updateBusinessProfile(profile.supplierId, buildBusinessProfilePayload(vendorCategories)));
      dispatch({
        type: UPDATE_BUSINESS_PROFILE_SUCCESS,
        payload: {
          profile: {
            ...profile,
            vendorCategories,
          },
        },
      });
      setCategoryPopupOpen(false);
    } catch (error) {
      setCategoryError({
        status: true,
        message: error?.message || "Unable to update categories. Please try again.",
      });
    } finally {
      setCategorySaving(false);
    }
  };
  return (
    <>
      {isSm ? (
        <>
          <NewBusinessProfileMobileView
            profile={profile}
            PublicProfile={PublicProfile}
            permissions={permissions}
            isEditView={isEditView}
            projects={projects}
            trustedCompaniesSection={trustedCompaniesSection}
          />
          <div className="mx-3 my-4 rounded-2xl border border-[#E8E6DD] bg-white p-4 shadow-sm">
            <div className="mb-4 flex items-center justify-between gap-3 rounded-xl bg-gradient-to-r from-[#FFF0E4] via-[#FFF8F1] to-[#F3F6FF] px-4 py-3">
              <div>
                <h2 className="text-sm font-semibold text-[#1F2937]">Products & Brands</h2>
                <p className="mt-1 text-xs text-[#6B7280]">Manage what your company supplies and the brands you deal in.</p>
              </div>
              <button
                type="button"
                onClick={() => setCategoryPopupOpen(true)}
                className="rounded-full border border-[#FD6600] px-3 py-1.5 text-xs font-semibold text-[#FD6600] transition hover:bg-[#FFF0E4]"
              >
                Edit
              </button>
            </div>
            <VendorCategoriesView
              profile={profile}
              isMobileView
              className="border-0 p-0 shadow-none"
              showHeader={false}
              showViewOnlyBadge={false}
              showMakes
            />
            {!profile?.vendorCategories?.length && (
              <div className="rounded-xl border border-dashed border-[#E8E6DD] bg-[#FCFCFA] px-4 py-5 text-sm text-[#6B7280]">
                No categories added yet. Tap Edit to add your marketplace taxonomy.
              </div>
            )}
          </div>
        </>
      ) : (
        <Grid
          ref={scrollContainerRef}
          
        >
          <BusinessProfileHead
            profile={profile}
            PublicProfile={PublicProfile}
            permissions={permissions}
            isEditView={isEditView}
          />
          <BusinessNavbar
            profile={profile}
            projects={projects}
            scrollContainerRef={scrollContainerRef}
          />
          <div id="component1">
            <BusinessProfileAbout
              profile={profile}
              PublicProfile={PublicProfile}
              permissions={permissions}
              isEditView={isEditView}
            />
          </div>

          {/* <div id="component3">
            <BusinessOfferingPage
                profile={profile}
                PublicProfile={PublicProfile}
                permissions={permissions}
                isEditView={isEditView}
              />
          </div> */}
          {trustedCompaniesSection}
          <div className="mx-[46px] my-8 rounded-2xl border border-[#E8E6DD] bg-white p-5 shadow-sm">
            <div className="mb-4 flex items-center justify-between gap-3 rounded-xl bg-gradient-to-r from-[#FFF0E4] via-[#FFF8F1] to-[#F3F6FF] px-4 py-3">
              <div>
                <h2 className="text-sm font-semibold text-[#1F2937]">Products & Brands</h2>
                <p className="mt-1 text-xs text-[#6B7280]">Manage what your company supplies and the brands you deal in.</p>
              </div>
              <button
                type="button"
                onClick={() => setCategoryPopupOpen(true)}
                className="rounded-full border border-[#FD6600] px-4 py-2 text-xs font-semibold text-[#FD6600] transition hover:bg-[#FFF0E4]"
              >
                Add/Edit Categories
              </button>
            </div>
            <VendorCategoriesView
              profile={profile}
              className="border-0 p-0 shadow-none"
              showHeader={false}
              showViewOnlyBadge={false}
              showMakes
            />
            {!profile?.vendorCategories?.length && (
              <div className="rounded-xl border border-dashed border-[#E8E6DD] bg-[#FCFCFA] px-4 py-6 text-sm text-[#6B7280]">
                No categories added yet. Click Edit Categories to add your marketplace taxonomy.
              </div>
            )}
          </div>
          <div id="component4">
            <Projects
                profile={profile}
                PublicProfile={PublicProfile}
                permissions={permissions}
                isEditView={isEditView}
                projects={projects.filter((project) => !project.isDeleted)}
              />
          </div>
          <div id="component5">
            <TopClient
                profile={profile}
                PublicProfile={PublicProfile}
                permissions={permissions}
                isEditView={isEditView}
              />
          </div>
          {profile?.businessProfile?.domains?.length > 0 && (
            <Domains
              profile={profile}
              PublicProfile={PublicProfile}
              permissions={permissions}
              isEditView={isEditView}
            />
          )}
          <div id="component6">
            <Grid
              container
              sx={{ mt: 3, marginBottom: "20px" }}
              direction={!isAwardExists ? "row-reverse" : "row"}
              spacing={1}

            >
              <Grid
                item
                xs={12}
                md={5.7}
                sm={12}
                style={{ marginY: "20px" }}
            
              >
                <Awards
                  awards={profile?.awards}
                  supplierId={profile?.supplierId}
                  // isPublicProfile={isPublicProfile}
                  permissions={permissions}
                />
              </Grid>
              <Grid item xs={12} md={5.7} sm={12}  >
                <CertificateSection
                  certificateDetails={bProfile?.certificateImages}
                  supplierId={profile?.supplierId}
                  // isPublicProfile={isPublicProfile}
                  permissions={permissions}
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
       )}
      <AddCategoryPopUp
        open={categoryPopupOpen}
        onClose={() => setCategoryPopupOpen(false)}
        onApply={handleCategoryUpdate}
        loading={categorySaving}
        selectedVendors={selectedVendorForCategories}
        showError={categoryError}
        title="Edit Categories"
        applyButtonLabel="Save Categories"
        footerNote="Selected categories will replace your current marketplace taxonomy."
        variant="drawer"
      />
    </>
  );
};

export default NewMyBusinesspage;






